import { useCallback, useMemo } from "react";

import { useApi } from "shared/services/api/useApi";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";

const useProjectsDashboardData = (endpointPathText) => {
    const { getDataAsync } = useApi();

    const { projectId } = useParams();

    const getDataLayoutApiCall = useCallback(async () => {
        const response = await getDataAsync("projectsDashboardDataLayout", {
            urlParams: [
                { name: "$projectId", value: projectId },
                { name: "$endpointPathText", value: endpointPathText },
            ],
        });

        const result = response.status === 204
            ? null
            : response.json();

        return result;

    }, [getDataAsync, projectId, endpointPathText]);

    const list = useQuery(`${endpointPathText}List`, getDataLayoutApiCall);

    return useMemo(() => {
        return {
            list,
        };
    }, [list]);
};

export default useProjectsDashboardData;

export const useProjectDashboardCurrency = () => {
    const { getDataAsync } = useApi();

    const { projectId } = useParams();

    const getCurrencyApiCall = useCallback(async () => {
        const response = await getDataAsync("getProjectsDashboardCurrency", {
            urlParams: [{ name: "$projectId", value: projectId }],
        });

        const result = response.status === 204
            ? null
            : response.json();

        return result;

    }, [getDataAsync, projectId]);

    const currency = useQuery("projectDashboardCurrency", getCurrencyApiCall);

    return useMemo(() => {
        return {
            currency,
        };
    }, [currency]);
};


export const useProjectsDashboardRelatedData = () => {
    const { getDataAsync } = useApi();
    const { projectId } = useParams();

    const getRelatedProjectsDashboardApiCall = useCallback(
        async (endpointSuffix) => {
            const response = await getDataAsync(
                "projectsDashboardRelatedProjects",
                {
                    urlParams: [
                        { name: "$projectId", value: projectId },
                        { name: "$endpointSuffix", value: endpointSuffix },
                    ],
                }
            );

            const result = response.status === 204
                ? null
                : response.json();

            return result;

        },
        [getDataAsync, projectId]
    );

    return useMemo(() => {
        const useRelatedProjectsDashboard = (endpointSuffix) =>
            useQuery([`${endpointSuffix}List`, endpointSuffix], () =>
                getRelatedProjectsDashboardApiCall(endpointSuffix)
            );

        return {
            useRelatedProjectsDashboard,
        };
    }, [getRelatedProjectsDashboardApiCall]);
};


export const useProjectById = () => {
    const { getDataAsync } = useApi();

    const { projectId } = useParams();

    const getProjectById = useCallback(async () => {
        const response = await getDataAsync("getProjectById", {
            urlParams: [{ name: "$projectId", value: projectId }],
        });

        const result = response.status === 204
            ? null
            : response.json();

        return result;

    }, [getDataAsync, projectId]);

    const project = useQuery("getProjectById", getProjectById);

    return useMemo(() => {
        return {
            project,
        };
    }, [project]);
};
